import React, { forwardRef, Ref } from "react";

import classnames from "classnames/bind";
import styles from "./XYChartLegend.module.scss";

import { Legend } from "../../components/Legend";

import type { XYChartLegendProps } from "../types";

const cx = classnames.bind(styles);

const XYChartLegend = (
  { scale, onPointerMove, active, data, left }: XYChartLegendProps,
  legendRef: Ref<HTMLDivElement>
) => {
  return (
    <div
      ref={legendRef}
      className={cx("container")}
    >
      <Legend
        scale={scale}
        orientation={"horizontal"}
        onMouseOver={onPointerMove}
        active={active}
        data={data}
        left={left}
      />
    </div>
  );
};

export default forwardRef(XYChartLegend);
